// @flow
import React from 'react';
import DashboardLoadingPlaceholder from './DashboardLoadingPlaceholderComponent';

type Props = {
  isLoading: boolean,
  name: string,
  companyName: string,
};

const CustomerInfoComponent = ({ isLoading, name, companyName }: Props) => (
  <div className="u-marginTop-s u-marginTop-m@large u-padding-horizontal-m u-padding-vertical-s u-padding-vertical-m@large dashboard-page__customer-info dashboard-page__item">
    {isLoading ? (
      <DashboardLoadingPlaceholder type="triple" />
    ) : (
      <div>
        <h3 className="u-fontSize-xxl">{name}</h3>
        <div className="u-fontSize-m">{companyName}</div>
      </div>
    )}
  </div>
);

CustomerInfoComponent.displayName = 'AccountManager';

export default CustomerInfoComponent;
